import React, { useEffect, useState } from "react";
import { useAdminApi } from "./adminApi";

export default function AdminPanelProductsDetails({ product, onClose }) {
  const api = useAdminApi();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // Получаем полную инфу о товаре (по id)
  useEffect(() => {
    if (!product) return;
    setLoading(true);
    api.get(`admin/products/${product.id}/`)
      .then(({ data, status }) => {
        if (status === 200) setDetails(data);
        else setDetails(null);
      })
      .finally(() => setLoading(false));
  }, [product]);

  if (!product) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-xl w-full relative p-6">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl font-bold"
          onClick={onClose}
          title="Закрыть"
        >
          &times;
        </button>

        {loading ? (
          <div className="py-16 text-center text-gray-400">Загрузка...</div>
        ) : !details ? (
          <div className="py-12 text-center text-red-500">Ошибка загрузки данных</div>
        ) : (
          <>
            <div className="flex gap-6 flex-col sm:flex-row">
              <div className="flex-shrink-0 w-full sm:w-48 flex flex-col items-center">
                <img
                  src={details.preview_image || "/no-image.png"}
                  alt={details.name}
                  className="w-36 h-36 object-contain border rounded mb-2"
                />
                {/* Галерея (если есть) */}
                {details.images && details.images.length > 0 && (
                  <div className="flex flex-wrap gap-1 justify-center mt-2">
                    {details.images.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt="Превью"
                        className="w-10 h-10 object-cover border rounded"
                      />
                    ))}
                  </div>
                )}
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-bold mb-2">{details.name}</h2>
                <div className="mb-1">
                  <span className="font-semibold text-gray-600">Категория:</span>{" "}
                  {details.category_name || "-"}
                </div>
                <div className="mb-1">
                  <span className="font-semibold text-gray-600">Остаток:</span>{" "}
                  {details.stock ?? "?"}
                </div>
                <div className="mb-1">
                  <span className="font-semibold text-gray-600">Цена:</span>{" "}
                  <span className="font-bold text-lg">{details.price} ₽</span>
                </div>
                {details.vendor_code && (
                  <div className="mb-1">
                    <span className="font-semibold text-gray-600">Артикул:</span> {details.vendor_code}
                  </div>
                )}
                {details.description && (
                  <div className="mt-3 text-gray-700 whitespace-pre-line">{details.description}</div>
                )}
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 transition"
                onClick={onClose}
              >
                Закрыть
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
